import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import * as crypto from 'crypto-js';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { PaymentRegistrationResponse } from '../interface/payvision/payment-registration-reponse.interface';
import { WorldpayXMLRegistration } from '../interface/worldpay-xml/worldpay-xml-registration.interface';

/**
 * @description this service help comunicate with payment service
 * when provider is WorldPayXML
 * @date 2018-08-08
 * @export
 * @class WorldpayXMLService
 */
@Injectable()
export class WorldpayXMLService {

    constructor(private _http: Http) { }

    /**
     * @description to get the Worldpay XML checkout
     *  registration form
     * @date 2018-07-27
     * @param {number} storeId
     * @param {paymentRegistrationRequest} WorldpayXMLRegistration
     * @returns {Observable<any>}
     * @memberof WorldpayXMLService
     */
    getWorldpayXMLForm(storeId: number, paymentRegistrationRequest: WorldpayXMLRegistration)
        : Observable<PaymentRegistrationResponse> {
        const headers = this.getPaymentHeaders();
        return this._http
            .post(decodeURIComponent(encodeURIComponent(ApiUrlConstants.paymentApiUrl + 'payments/store/' + storeId +
            '/payment-checkout-form ')), paymentRegistrationRequest, { headers: headers })
            .map((res: Response) => res.json())
            .catch(this.handleErrorObservable);
    }

    /**
     * @description this is used to get
     * payment headers
     * @date 2018-07-26
     * @returns {Headers}
     * @memberof WorldpayXMLService
     */
    getPaymentHeaders(): Headers {
        const headers = new Headers();
        const authHeader = 'PAY ' + environment.paymentApiKey + ':' + this.getHashedValue();
        headers.append('authorization', authHeader);
        return headers;
    }

    /**
     * @description this method is used to
     * get payment crypto hashed value
     * @date 2018-07-26
     * @returns {string}
     * @memberof WorldpayXMLService
     */
    getHashedValue(): string {
        const shavalue = crypto.HmacSHA1(environment.paymentSecurityKey, environment.paymentServiceKey);
        return crypto.enc.Base64.stringify(shavalue);
    }

    /**
    * To handle the obervable error response
    * @param  {Response|any} error
    */
    private handleErrorObservable(error: Response | any) {
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/worldpay-xml.service.ts